import { useMemo } from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// The authentic MVM mark, vector-traced from the brand asset — crisp at any
// size. Steam wisps rise off it; drips, beads and a glisten are masked to it.
export const HeroHeadline = ({ delay = 0.5 }) => {
  const drips = useMemo(
    () =>
      Array.from({ length: 6 }, () => ({
        left: 4 + Math.random() * 92,
        len: 40 + Math.random() * 45,
        w: 3 + Math.random() * 2.5,
        dur: 8 + Math.random() * 5,
        delay: Math.random() * 9,
      })),
    []
  );
  const beads = useMemo(
    () =>
      Array.from({ length: 7 }, () => ({
        left: 4 + Math.random() * 92,
        top: 10 + Math.random() * 80,
        r: 1.4 + Math.random() * 2,
        dur: 3 + Math.random() * 4,
        delay: Math.random() * 4,
      })),
    []
  );
  const steam = useMemo(
    () =>
      Array.from({ length: 4 }, (_, i) => ({
        left: 8 + i * 22 + Math.random() * 10,
        top: 5 + Math.random() * 25,
        dur: 6 + Math.random() * 4,
        delay: Math.random() * 6,
      })),
    []
  );

  return (
    <h1 className="w-[170px] sm:w-[210px] md:w-[250px] lg:w-[290px] max-w-full mb-8">
      <span className="sr-only">MVM</span>
      <span className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay, ease: EASE }}
        >
          <div className="relative" data-testid="hero-logo-mark">
            <img src="/assets/brand/logo-mark.svg" alt="MVM" className="w-full h-auto block" />
            {steam.map((s, i) => (
              <span
                key={`steam-${i}`}
                className="hero-steam"
                aria-hidden="true"
                style={{
                  left: `${s.left}%`,
                  top: `${s.top}%`,
                  animationDuration: `${s.dur}s`,
                  animationDelay: `${s.delay}s`,
                }}
              />
            ))}
            <div
              className="hero-fx-mask"
              aria-hidden="true"
              style={{
                WebkitMaskImage: "url(/assets/brand/logo-mark.svg)",
                maskImage: "url(/assets/brand/logo-mark.svg)",
                WebkitMaskSize: "100% 100%",
                maskSize: "100% 100%",
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
              }}
            >
              <div className="hero-sheen hero-sheen-html" />
              {beads.map((b, i) => (
                <span
                  key={`bead-${i}`}
                  className="hero-bead hero-bead-html"
                  style={{
                    left: `${b.left}%`,
                    top: `${b.top}%`,
                    width: b.r * 2,
                    height: b.r * 2,
                    animationDuration: `${b.dur}s`,
                    animationDelay: `${b.delay}s`,
                  }}
                />
              ))}
              {drips.map((d, i) => (
                <span
                  key={`drip-${i}`}
                  className="hero-drip hero-drip-html"
                  style={{
                    left: `${d.left}%`,
                    width: d.w,
                    height: d.len,
                    animationDuration: `${d.dur}s`,
                    animationDelay: `${d.delay}s`,
                  }}
                />
              ))}
            </div>
          </div>
        </motion.span>
      </span>
    </h1>
  );
};
